






















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class WebPiano extends Vue {
  audio = null;
  gainOscillators: GainOscillator[] = [];

  mounted() {
    const audio = new AudioContext();

    for (let i = -36; i < 36; i++) {
      const gain = audio.createGain();
      const oscillator = audio.createOscillator();

      oscillator.connect(gain);
      gain.connect(audio.destination);
      gain.gain.value = 0.5;

      oscillator.frequency.value = 440 * Math.pow(Math.pow(2, 1 / 12), i);

      this.gainOscillators.push(
        {
          gain: gain,
          oscillator: oscillator
        }
      );
    }

    this.gainOscillators[36].oscillator.start();
    this.gainOscillators[38].oscillator.start();
  }
}
